/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 * Based on https://github.com/mattdesl/point-util
 */


export function isClockwise (points: any): boolean {
    let sum = 0;
    for (let i = 0; i < points.length; i++) {
        let o = (i === points.length - 1) ? points[0] : points[i + 1];
        sum += (o.x - points[i].x) * (o.y + points[i].y);
    }
    return sum > 0;
}

export function pointInPoly (points: any, test: any): boolean {
    //http://stackoverflow.com/a/2922778
    let c: boolean = false,
        nvert = points.length,
        i = 0,
        j = nvert - 1,
        testx = test.x,
        testy = test.y;

    for (; i < nvert; j = i++) {
        if (((points[i].y > testy) != (points[j].y > testy))
            && (testx < (points[j].x - points[i].x)
                * (testy - points[i].y) / (points[j].y - points[i].x) + points[i].x))
            c = !c;
    }
    return c;
}

export function indexOfPointInList(other: any, list: any): number {
    for (let i = 0; i < list.length; i++) {
        let p = list[i];
        if (p.x == other.x && p.y == other.y)
            return i;
    }

    return -1;
}

export function isCollinear (a: any, b: any, c: any): boolean {
    let r = (b[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b[1] - a[1]);
    let eps = 0.0000001;

    if (Math.abs(r) < eps)
        return true;

    //poly2tri also complains about this:
    if ((a[0] === b[0] && b[0] === c[0]) || (a[1] === b[1] && b[1] === c[1]))
        return true;

    return false;
}

export function getBounds(contour: any) : any {
    let minX = Number.MAX_VALUE,
        minY = Number.MAX_VALUE,
        maxX = -Number.MAX_VALUE,
        maxY = -Number.MAX_VALUE;
    for (let i = 0; i < contour.length; i++) {
        let v = contour[i];
        minX = Math.min(minX, v.x);
        minY = Math.min(minY, v.y);
        maxX = Math.max(maxX, v.x);
        maxY = Math.max(maxY, v.y);
    }

    return {
        minX: minX,
        maxX: maxX,
        minY: minY,
        maxY: maxY
    };
}
